import Card from "@mui/material/Card";
import { useFormik } from "formik";
import * as Yup from "yup";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import bgImage from "assets/images/login-icon.jpg";
import { Link, useNavigate } from "react-router-dom";
import { forgotPassword } from "Apis/signIn";
import { LoginFormContext } from "context/LoginFormContext";
import { useContext } from "react";
import Cookies from "js-cookie";
import { AuthRouteJson } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";
import { MdArrowBack } from "react-icons/md";

function Cover() {
  const navigate = useNavigate();
  const { setNotification } = useContext(LoginFormContext);
  const { sideNav } = colors;

  const validationSchema = Yup.object({
    email: Yup.string().required("Email is required!"),
  });
  const handleSubmit = async (values) => {
    let response = await forgotPassword(values);
    if (response?.status === 200) {
      navigate(AuthRouteJson.otp);
      localStorage.setItem("resetToken", response?.data?.data?.token);
      Cookies.set("otp", response?.data?.data?.otp);
      Cookies.set("otpEmail", values?.email);
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });
  return (
    // <CoverLayout>
    <MDBox
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        justifyContent: "center",
        background: `${sideNav.hover}`,
      }}
    >
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          width: "80%",
          maxWidth: "1030px",
          padding: "20px",
          gap: "25px",
          background: "#fff",
          borderRadius: "8px",
          margin: "0 auto",
          justifyContent: "center",
          "@media (max-width:1020px)": {
            flexDirection: "column",
          },
          "@media (max-width:767px)": {
            width: "90%",
          },
        }}
      >
        <MDBox
          sx={{
            width: "auto",
            height: "460px",
            "@media (max-width: 1020px)": { width: "auto", height: "170px" },
            // "@media (max-width:767px)": { width: "auto", height: "200px" },
          }}
        >
          <img
            src={bgImage}
            width={100}
            height={100}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </MDBox>
        <Card
          sx={{
            gap: "10px",
            width: "52%",
            background: "transparent",
            boxShadow: "none",
            "@media (max-width:1020px)": {
              width: "100%",
            },
          }}
        >
          <MDBox
            // variant="gradient"
            // bgColor="info"
            // borderRadius="lg"
            // coloredShadow="success"
            // mx={2}
            // mt={-3}
            // py={2}
            // mb={1}
            // p={{ xl: 2.25 }}
            // pt={4}
            textAlign="center"
          >
            <MDTypography
              variant="h4"
              mb="8px"
              fontWeight="medium"
              color="#334155"
              fontSize="1.5rem"
            >
              Forgot Password
            </MDTypography>
            <MDTypography component="p" color="black" fontSize="14px" mb={"10px"}>
              Enter your email and we&apos;ll send you a otp to reset your password.
            </MDTypography>
          </MDBox>
          <MDBox p={{ xl: 2.25 }}>
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDBox mb={2.25}>
                <MDInput
                  variant="standard"
                  type="email"
                  label="Email"
                  fullWidth
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <MDBox
                    component="p"
                    sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
                  >
                    {formik.errors.email}
                  </MDBox>
                )}
              </MDBox>
              <MDBox sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <MDTypography
                  component={Link}
                  to={AuthRouteJson.signin}
                  fontWeight="regular"
                  color="text"
                  sx={{
                    textAlign: "right",
                    fontSize: "14px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MdArrowBack style={{ marginLeft: "5px" }} />
                  Back to login
                </MDTypography>
              </MDBox>
              <MDBox mt={3} mb={1}>
                <SubmitButton type="submit" btnText={"submit"} width="100%" />
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
    // </CoverLayout>
  );
}

export default Cover;
